export default __webpack_public_path__ + "static/media/is-there-anybody-out-there.9c1c2167.jpg";